var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"20px"}},[_c('DescriptionList',{attrs:{"title":"","col":4,"data":_vm.basicInfo},scopedSlots:_vm._u([{key:"status",fn:function({ record }){return [_c('Tag',{attrs:{"type":record.value === '激活' ? 'success' : 'default'}},[_vm._v("\n\t\t\t\t"+_vm._s(record.value)+"\n\t\t\t")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }